export default __webpack_public_path__ + "static/media/bg-1.5bee343d.jpg";